import { MigrationSpec } from "../migration.models"

const aiAgentSessionDropTtl: MigrationSpec = {
  type: "MIGRATE_AI_AGENT_SESSION_DROP_TTL",
  collection: "AiAgentSessions",
  risk: "INDEX",
  title: {
    en: "AI agent sessions: end with the conversation, not after 90 days",
    tr: "AI ajan oturumları: 90 gün sonra değil, konuşmayla birlikte bitsin"
  },
  description: {
    en:
      "Drops the 90-day TTL index (updatedAt_ttl) on AiAgentSessions. qpien-ai now deletes a " +
      "session when its conversation closes, and the per-minute reconcile deletes and logs " +
      "(ai_session_orphan) any session left behind a closed or deleted conversation.",
    tr:
      "AiAgentSessions'taki 90 günlük TTL index'ini (updatedAt_ttl) kaldırır. qpien-ai artık bir " +
      "oturumu konuşması kapanınca siler; dakikalık mutabakat da kapanmış ya da silinmiş bir " +
      "konuşmadan geriye kalan oturumu siler ve loglar (ai_session_orphan)."
  },
  affectedFilter: { _id: null },
  sampleFields: ["customer", "conversation", "updatedAt"],
  indexes: {
    mustDrop: [{ keys: { updatedAt: 1 } }]
  },
  notes: [
    {
      en: "Deploy qpien-ai first: until then nothing deletes a session but this index.",
      tr: "Önce qpien-ai deploy edilmelidir: o zamana kadar oturumu bu index'ten başka silen yok."
    },
    {
      en:
        "The first reconcile passes after the deploy delete the sessions of conversations that " +
        "closed before it, each logged as ai_session_orphan; that burst is the backlog, not a bug.",
      tr:
        "Deploy'dan sonraki ilk mutabakat turları, deploy'dan önce kapanmış konuşmaların oturumlarını " +
        "siler ve her birini ai_session_orphan olarak loglar; bu ilk yığın birikmiş kayıttır, hata değildir."
    }
  ]
}

export default aiAgentSessionDropTtl
